import axios from "axios";
import { useEffect, useState } from "react";

const GetAccountStatusData = ({onStatusChange, selectedStatus, totalAccounts, accountStatusCount}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    const handleStatusCLick = (status) => {
        const newStatus = selectedStatus === status ? null : status;
        onStatusChange(newStatus);
    };
    return(
        <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-3 md:p-4 mb-4 w-full h-fit">
            <h1 className="font-bold text-base md:text-lg mb-2">All Total Accounts ({totalAccounts})</h1>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-4">
                <div 
                    onClick={() => handleStatusCLick('Activated')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Activated' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Activated</h3>
                        <span className="text-xs md:text-sm text-gray-600">&lt; 30 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Activated')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sirius')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sirius' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Sirius</h3>
                        <span className="text-xs md:text-sm text-gray-600">30-50 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Sirius')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Spica')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Spica' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Spica</h3>
                        <span className="text-xs md:text-sm text-gray-600">50-70 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Spica')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sargas')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sargas' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Sargas</h3>
                        <span className="text-xs md:text-sm text-gray-600">70-90 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Sargas')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Sabik')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Sabik' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Sabik</h3>
                        <span className="text-xs md:text-sm text-gray-600">90-365 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Sabik')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Dormant')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Dormant' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Dormant</h3>
                        <span className="text-xs md:text-sm text-gray-600">&gt; 365 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{accountStatusCount.find(item => item.churn_profile === 'Dormant')?.count || "0"}</span>
                </div>
            </div>
        </div>
    )
}

export default GetAccountStatusData;